// Copyright © 2023 CATTLEytics Inc.
export enum AnimalStatus {
  Active = 'active',
  AliveAndSold = 'alive-and-sold',
  Dead = 'dead',
  DeadAndSold = 'dead-and-sold',
  Sold = 'sold',
  Unknown = 'unknown',
}
